import { memo, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Title from '../../atoms/title';
import ScrollView from '../../molecules/scrollView';

import { makerCoinCode } from '../../../utils/common';
import { SELECT_COIN } from '../../../store/modules/coin';

interface Props {
  title?: boolean;
}

interface Exchange {
  name: string;
  upbit: number;
  bithumb: number;
  cobit: number;
}

const Favorite = (props: Props) => {

  const {
    upbitData = [],
    upbitMap = {},
    bithumbData = [],
    bithumbMap = {},
    cobitData = [],
    cobitMap = {},
    favoriteData = [],
    favoriteMap = {}
  } = useSelector((state: any) => ({
    upbitData: state.upbit.data,
    upbitMap: state.upbit.m,
    bithumbData: state.bithumb.data,
    bithumbMap: state.bithumb.m,
    cobitData: state.cobit.data,
    cobitMap: state.cobit.m,
    favoriteData: state.favorite.data,
    favoriteMap: state.favorite.map
  }))

  const dispatch = useDispatch();

  const [data, setData] = useState<Exchange[]>([]);

  useEffect(() => {
    
    let data = favoriteData.map((favoriteCoin: string) => {
      let c = makerCoinCode(favoriteCoin);
      let upbitIndex = upbitMap[c.upbit];
      let bithumbIndex = bithumbMap[c.bithumb];
      let cobitIndex = cobitMap[c.cobit];
      
      let upbitPrice = upbitData[upbitIndex]?.close || 0;
      let bithumbPrice = bithumbData[bithumbIndex]?.close || 0;
      let cobitPrice = cobitData[cobitIndex]?.close || 0;
      
      return {
        name: c.default,
        upbit: upbitPrice,
        bithumb: bithumbPrice,
        cobit: cobitPrice,
      }
    })

    setData(data)
  }, [upbitData, bithumbData, cobitData, favoriteData, upbitMap, bithumbMap, cobitMap]);

  const onClickHandler = (coin: string) => {
    dispatch({
      type: SELECT_COIN,
      payload: {
        select: coin
      }
    })
  }

  return (
    <>
      {props.title && <Title value="즐겨찾기" bold />}
      <ScrollView
        data={data}
        heads={['한글명', '업비트', '빗썸', '코빗']}
        onRowClick={onClickHandler}
      />
    </>
  );
};

export default memo(Favorite);
